import { FC, useState } from 'react';
import { Editor, useEditorState } from '@tiptap/react'
import { BubbleMenu } from '@tiptap/react/menus'
import { Icon } from 'Components/UI';
import { isEqual } from 'Utils/ObjectUtils';
import { ButtonIcon, Container, Divider, Main, Row } from './styles';

type EditorStateType = {
  isBold: boolean;
  isItalic: boolean;
  isUnderline: boolean;
  isStrike: boolean;
}

interface ISelectedMenu {
  editor: Editor;
  togglePreventClose: (value: boolean) => void;
}

const SelectedMenu: FC<ISelectedMenu> = ({ editor, togglePreventClose }) => {
  const [state, setState] = useState<EditorStateType>({
    isBold: false,
    isItalic: false,
    isUnderline: false,
    isStrike: false,
  })

  useEditorState({
    editor, selector(context) {
      const newState = {
        isBold: context.editor.isActive('bold'),
        isItalic: context.editor.isActive('italic'),
        isUnderline: context.editor.isActive('underline'),
        isStrike: context.editor.isActive('strike'),
      }
      if (!isEqual(state, newState)) {
        setState(newState)
      }
    }
  })

  const ToggleBold = () => {
    editor.chain().focus().toggleBold().run();
    togglePreventClose(true);
  }

  const ToggleItalic = () => {
    editor.chain().focus().toggleItalic().run();
    togglePreventClose(true);
  }

  const ToggleUnderline = () => {
    editor.chain().focus().toggleUnderline().run();
    togglePreventClose(true);
  }

  const ToggleStrike = () => {
    editor.chain().focus().toggleStrike().run();
    togglePreventClose(true);
  }

  return (
    <BubbleMenu editor={editor}>
      <Container>
        <Main>
          <Row>
            <ButtonIcon
              active={state.isBold}
              onClick={ToggleBold}
            >
              <Icon icon="bold" className="iconButton" />
            </ButtonIcon>
            <ButtonIcon
              active={state.isItalic}
              onClick={ToggleItalic}
            >
              <Icon icon="italic" className="iconButton" />
            </ButtonIcon>
            <ButtonIcon
              active={state.isUnderline}
              onClick={ToggleUnderline}
            >
              <Icon icon="underline" className="iconButton" />
            </ButtonIcon>
            <ButtonIcon
              active={state.isStrike}
              onClick={ToggleStrike}
            >
              <Icon icon="lineThrough" className="iconButton" />
            </ButtonIcon>
          </Row>
          {/* <Divider><div className="divider" /></Divider>
          <Row>
            <ButtonIcon>
              <Icon icon="link" className="iconButton" />
            </ButtonIcon>
          </Row> */}
        </Main>
      </Container>
    </BubbleMenu>
  )
}

export default SelectedMenu;
